{
  "unknown_state": "その他の状態",
  "financial": {
    "pending_payment": "入金待ち",
    "partially_paid": "一部入金",
    "paid": "支払い済み",
    "partially_refunded": "一部返金",
    "refunded": "返金済み",
    "cancelled": "キャンセル"
  },
  "fulfillment": {
    "unfulfilled": "未準備",
    "preparing": "準備中",
    "ready": "準備完了・発送待ち",
    "shipped": "発送済み",
    "in_transit": "配送中",
    "delivered": "お届け済み",
    "partial": "一部発送",
    "pickup_ready": "店頭受取可",
    "picked_up": "受け渡し済み",
    "return_requested": "返品の申し込み",
    "return_received": "返品受領"
  },
  "parcel": {
    "pending": "未発送",
    "preparing": "準備中",
    "ready": "梱包済み",
    "shipped": "発送済み",
    "in_transit": "配送中",
    "delivered": "お届け済み",
    "pickup_ready": "店頭受取可",
    "picked_up": "受け渡し済み",
    "cancelled": "キャンセル"
  },
  "review": {
    "none": "確認不要",
    "pending_review": "責任者の確認待ち",
    "approved": "確認済み",
    "rejected": "不承認"
  },
  "tax": {
    "domestic_taxable": "消費税10%（国内）",
    "export_exempt": "輸出免税 0%",
    "tax_free_tourist": "免税（店頭）",
    "non_taxable": "消費税なし"
  },
  "evidence": {
    "not_required": "輸出証明は不要",
    "missing": "輸出証明がない",
    "complete": "輸出証明を保存済み",
    "after_shipping": "発送後に輸出証明を保存"
  },
  "channel": {
    "web": "ウェブ",
    "pos": "店頭",
    "ebay": "eBay",
    "whatnot": "Whatnot",
    "mercari": "メルカリ",
    "other": "その他"
  },
  "delivery": {
    "ship": "配送（郵便・宅配）",
    "pickup": "店頭受取"
  },
  "customer_kind": {
    "guest": "ゲスト",
    "registered": "会員"
  },
  "views": {
    "awaiting_bank_transfer": "入金待ち（銀行振込）",
    "to_prepare": "準備待ち",
    "ready_to_ship": "発送待ち",
    "pickup_ready": "店頭受取",
    "export_missing_evidence": "海外・書類待ち",
    "returns": "返品・返金",
    "flagged": "要確認",
    "to_ship": "支払い済み・未発送"
  },
  "columns": {
    "number": "注文",
    "customer": "お客様",
    "total": "合計",
    "tax": "税",
    "payment": "支払い",
    "fulfillment": "商品",
    "placed": "注文日時",
    "risk": "問題",
    "actions": "操作"
  },
  "filters": {
    "q": "検索",
    "q_placeholder": "注文番号、名前、メール、追跡番号、商品コード",
    "channel": "販売場所",
    "delivery": "受け取り方法",
    "country": "国",
    "evidence": "輸出証明",
    "customer_kind": "ゲスト・会員"
  },
  "list": {
    "intro": "ウェブと店頭の注文をまとめて表示します。注文を開いて次の作業をします。",
    "create": "注文を作成（チャット・LINE）",
    "new": "新着",
    "bulk_ready": "準備完了にする（{{count}}）",
    "bulk_ready_title": "{{count}} 件を準備完了にしますか？",
    "bulk_ready_consequence": "準備中の注文だけが変わります。お客様に「準備完了」のメールが届きます。",
    "bulk_ready_done_other": "{{count}} 件を準備完了にしました",
    "bulk_ready_partly": "{{ok}} 件完了、{{failed}} 件は変更できませんでした（注文を開いて確認）",
    "bulk_ship": "発送する（{{count}}）",
    "print_slips": "納品書を印刷",
    "print_invoices": "インボイス（輸出用）を印刷",
    "print_packing_slip_other": "{{count}} 件の納品書を作成しています",
    "print_commercial_invoice_other": "{{count}} 件のインボイス（輸出用）を作成しています",
    "print_hint": "数秒後、各注文の「印刷」に表示されます。",
    "print_none": "選んだ注文に海外発送はありません。",
    "print_partly": "{{ok}} 件作成、{{failed}} 件は作成できませんでした"
  },
  "steps": {
    "title": "次の作業",
    "title_pickup": "次の作業（店頭受取）",
    "nothing_left": "この注文の作業は終わりました。",
    "label": {
      "confirm_payment": "入金確認",
      "start_preparing": "準備開始",
      "mark_ready": "準備完了",
      "ship": "発送",
      "mark_delivered": "お届け済み",
      "pickup_ready": "店頭受取可にする",
      "hand_over": "受け渡し済み"
    },
    "state": {
      "done": "完了",
      "now": "今やる作業",
      "later": "まだ",
      "blocked": "今はできません"
    },
    "why": {
      "done": "完了しています。",
      "needs_previous": "先に前の作業をしてください。",
      "not_paid": "まだ入金がありません。",
      "under_review": "先に責任者の確認が必要です。",
      "cancelled": "この注文はキャンセルされています。",
      "paid_elsewhere": "銀行振込ではないので、ここで確認するものはありません。",
      "service_says_no": "この注文では今はできません。"
    },
    "done": {
      "start_preparing": "{{number}}：準備中",
      "mark_ready": "{{number}}：準備完了",
      "pickup_ready": "{{number}}：店頭受取可",
      "mark_delivered": "{{number}}：お届け済み",
      "hand_over": "{{number}}：受け渡し済み"
    },
    "done_hint": {
      "start_preparing": "お客様の注文ページに「準備中」と表示されます。",
      "mark_ready": "お客様に「準備完了」のメールが届きます。",
      "pickup_ready": "お客様に「受け取りに来られます」のメールが届きます。",
      "mark_delivered": "お客様には「お届け済み」と表示されます。",
      "hand_over": "この注文は完了です。"
    },
    "confirm": {
      "mark_delivered": {
        "title": "すべてお届け済みにしますか？",
        "body": "配送会社かお客様から届いたと連絡があったときに使います。元に戻せません。"
      },
      "hand_over": {
        "title": "お客様に商品を渡しましたか？",
        "body": "先にお客様のスマホの注文番号を確認してください。元に戻せません。"
      }
    }
  },
  "detail": {
    "back": "注文一覧",
    "load_failed": "注文を開けませんでした",
    "placed": "注文日時",
    "print": "印刷",
    "contact": "お客様にメール",
    "mail_subject": "ご注文 {{number}} について",
    "cancel": "注文をキャンセル",
    "consignment_scope": "この注文の委託品だけを表示しています。",
    "export_proof": "輸出証明を保存してください",
    "export_proof_body": "この荷物は消費税なしで海外に送っています。郵便局の引受証か輸出許可書を保存してください。",
    "export_proof_open": "証明を追加",
    "refund": "返金する",
    "edit_address": "変更",
    "cancelled_refund_pending": "キャンセル済み — 返金中"
  },
  "lines": {
    "title_other": "{{count}} 点",
    "sealed": "未開封",
    "consigned": "委託品",
    "consigned_note": "レシートでは「委託品／インボイス対象外」と表示されます（店の売上は手数料のみ）。",
    "qty_other": "{{count}} 個",
    "sent": "{{of}} 個中 {{count}} 個発送",
    "refunded": "{{count}} 個返金",
    "each": "単価",
    "discount": "割引",
    "stock_now": "いま：",
    "stock_history": "在庫の履歴",
    "unit_states": {
      "pending": "確保中",
      "released": "注文から外しました"
    }
  },
  "totals": {
    "title": "金額",
    "subtotal": "商品",
    "discount": "割引",
    "shipping": "送料",
    "duties": "前払いの関税",
    "total": "合計（税込）",
    "tax_included": "うち消費税",
    "received": "受け取り済み",
    "refunded": "返金",
    "outstanding": "未払い"
  },
  "payments": {
    "title": "支払い",
    "unavailable": "今は支払いの詳細を表示できません。注文のほかの部分は使えます。",
    "none": "まだ支払いはありません。",
    "amount": "金額",
    "received": "入金額",
    "fee": "カード端末の手数料",
    "net": "店の受取額",
    "refunded": "返金",
    "reference": "支払いコード",
    "due": "支払い期限",
    "captured_at": "入金日",
    "notice_title": "お客様からの振込連絡",
    "notice_line": "{{name}} 様より：",
    "refunds": "返金",
    "method": {
      "bank_transfer_manual": "銀行振込",
      "cash": "現金",
      "edc_external": "カード端末",
      "pay_in_store": "店頭払い",
      "store_credit": "ストアクレジット",
      "none": "未選択",
      "other": "その他の方法"
    },
    "status": {
      "pending": "待ち",
      "requires_action": "お客様の操作待ち",
      "processing": "確認中",
      "authorized": "承認済み",
      "captured": "入金済み",
      "failed": "失敗",
      "expired": "期限切れ",
      "partially_refunded": "一部返金",
      "refunded": "返金済み"
    },
    "refund_status": {
      "requested": "申請中",
      "pending_approval": "承認待ち",
      "approved": "承認済み",
      "processing": "返金中",
      "completed": "返金済み",
      "failed": "失敗",
      "rejected": "不承認"
    }
  },
  "address": {
    "title": "お届け先",
    "pickup_title": "店頭受取",
    "pickup_body": "お客様がお店に来ます。スマホの注文番号を確認してください。",
    "none": "住所がありません。",
    "map": "地図を開く",
    "opens_new_tab": "（新しいタブで開きます）",
    "billing": "請求先",
    "shipping_method": "選ばれた配送",
    "export_hint": "消費税なしで海外に送ります。",
    "export_open": "輸出証明"
  },
  "timeline": {
    "title": "履歴",
    "empty": "まだありません。",
    "by": "{{name}}",
    "customer_sees": "お客様にも表示",
    "other": "変更を記録",
    "types": {
      "placed": "注文受付",
      "paid": "入金確認",
      "payment_notice_received": "お客様から振込連絡",
      "payment_short": "合計より少なく入金",
      "payment_over": "合計より多く入金",
      "payment_due_extended": "支払い期限を延長",
      "variance_resolved": "過入金を処理",
      "overpayment_refunded": "過入金を返金",
      "captured_after_cancel": "キャンセル後に入金",
      "preparing": "準備開始",
      "ready": "準備完了",
      "shipped": "発送",
      "in_transit": "配送中",
      "delivered": "お届け済み",
      "pickup_ready": "店頭受取可",
      "picked_up": "店頭で受け渡し",
      "pickup_recorded": "レジで受け取りを記録",
      "tracking_corrected": "追跡番号を修正",
      "cancel_requested": "お客様からキャンセル依頼",
      "cancelled": "キャンセル",
      "refunded": "返金",
      "return_requested": "返品の申し込み",
      "return_received": "返品受領",
      "return_refund_requested": "返品の返金を申請",
      "pos_return_recorded": "レジで返品",
      "pos_void_recorded": "レジで取り消し",
      "void": "支払いを取り消し",
      "hold_expired": "取り置き期限切れ",
      "hold_lost": "カードを確保できませんでした",
      "hold_reacquired": "カードを再確保",
      "hold_renewed": "取り置きを延長",
      "oversell_conflict": "同じカードが二重に売れました",
      "note": "メモ",
      "customer_note": "お客様からのメッセージ",
      "flag_set": "問題として記録",
      "flag_cleared": "問題を確認済み",
      "document_requested": "書類を依頼",
      "document_issued": "書類を作成",
      "export_evidence_added": "輸出証明を追加",
      "email_resent": "メールを再送",
      "edited": "注文を変更"
    }
  },
  "actor": {
    "customer": "お客様",
    "pos": "レジ",
    "system": "システム",
    "staff": "スタッフ",
    "you": "あなた"
  },
  "notes": {
    "title": "スタッフ用メモ",
    "label": "メモを追加",
    "placeholder": "例：ギフト包装希望",
    "hint": "メモはスタッフだけが見られます。",
    "add": "メモを追加",
    "saved": "メモを追加しました",
    "tags": "タグ",
    "tag_placeholder": "例：ギフト",
    "add_tag": "タグを追加",
    "remove_tag": "タグ {{tag}} を外す"
  },
  "flags": {
    "title": "問題",
    "under_review": "この注文は責任者の確認待ちです。まだ商品を送らないでください。",
    "tap_to_fix": "問題があります — タップして直し方を見る",
    "other": "確認が必要",
    "fraud_risk": "不正の可能性",
    "address_mismatch": "請求先と配送先の国が違う",
    "high_value": "高額注文",
    "manual_review": "確認のため保留",
    "first_order_international": "海外からの初回注文",
    "overpaid": "多く支払われた",
    "underpaid": "支払いが足りない",
    "oversell_conflict": "同じカードが二重に売れた",
    "fix": {
      "fraud_risk": "お客様の情報を確認し、必要なら連絡してください。続けるかは責任者が決めます。",
      "address_mismatch": "発送前にお客様に住所を確認してください。",
      "high_value": "注文を確認し、責任者が確認済みにします。",
      "manual_review": "メモを確認し、責任者が確認済みにします。",
      "first_order_international": "注文は止まっていません。住所と税関データを確認してください。",
      "overpaid": "差額を返金するかストアクレジットにします（責任者）。",
      "underpaid": "残りの振込をお願いするか、届いた分で受け付けます。",
      "oversell_conflict": "要確認ページで、どちらのお客様にカードを渡すか決めてください。",
      "other": "注文とメモを確認してください。"
    },
    "open_conflicts": "要確認ページを開く",
    "clear": "確認済み — 続けてよい",
    "clear_title": "この問題を確認済みにしますか？",
    "clear_consequence": "注文を進められるようになります。確認した内容を書いてください。",
    "cleared": "問題を確認済みにしました",
    "hold": "確認のため保留する",
    "hold_title": "この注文を保留しますか？",
    "hold_consequence": "責任者が確認するまで商品を送れません。理由を書いてください。",
    "held": "確認のため保留しました"
  },
  "cancel": {
    "title": "{{number}} をキャンセル",
    "description": "商品を送る前だけです。",
    "why": "理由",
    "reasons": {
      "customer_request": "お客様の希望",
      "payment_expired": "入金がなかった",
      "out_of_stock": "商品に問題がある",
      "fraud_suspected": "不正の疑い",
      "duplicate": "二重注文",
      "other": "その他"
    },
    "note": "ひとこと（履歴に残ります）",
    "note_required": "「その他」はひとこと書いてください。",
    "restock": "商品を販売に戻す",
    "refund": "お金を返す",
    "consequence": "お客様に「キャンセル」のメールが届きます。",
    "consequence_refund": "お客様に「キャンセル」のメールが届きます。返金は記録だけです — 銀行で振り込んでください。",
    "confirm": "注文をキャンセル",
    "done": "{{number}} をキャンセルしました",
    "done_hint": "商品は販売に戻りました。",
    "done_refund_hint": "銀行で返金の振込を忘れずに。",
    "write_off": "商品はどうなりましたか？",
    "write_offs": {
      "damaged": "破損 — 販売できない",
      "lost": "紛失 — 見つからない"
    },
    "done_refund_approval": "返金 ¥{{amount}} — 先に店長の承認が必要です（「返金」欄）。",
    "done_write_off": "商品は在庫の履歴で除却されました。",
    "done_stock_pending": "商品はまもなく販売中に戻ります。"
  },
  "queue": {
    "intro": "銀行口座と照らし合わせる振込です。振込連絡があったものが先に表示されます。",
    "tabs": "表示する振込",
    "tab_all": "入金確認待ち",
    "tab_overdue": "期限切れ",
    "to_pay": "請求額",
    "due": "支払い期限",
    "no_due": "期限なし",
    "overdue": "期限切れ — 取り置きは解除されます",
    "days_left": "残り {{d}} 日 {{h}} 時間",
    "hours_left": "残り {{h}} 時間",
    "notice": "振込連絡",
    "no_notice": "まだありません",
    "has_slip": "控えあり",
    "remind": "催促メール",
    "remind_aria": "{{number}} の振込先をもう一度メール",
    "reminded": "{{number}}：振込先をもう一度メールしました",
    "cancel": "入金なし → 取消",
    "cancel_aria": "{{number}} をキャンセル（入金なし）",
    "empty": "確認する振込はありません。",
    "empty_overdue": "期限切れの振込はありません。"
  },
  "transfer": {
    "title": "入金確認 — お金が届きました",
    "description": "{{number}} · {{name}}",
    "expected": "未払い額",
    "notice": "お客様の連絡：{{name}} 様が {{amount}} を振込。",
    "amount": "届いた金額",
    "short": "合計より {{amount}} 少ない — どうしますか？",
    "short_hold": "残りを待つ（注文は入金待ちのまま）",
    "short_capture_partial": "届いた分で受け付ける（一部入金になります）",
    "short_contact": "注文ページからお客様にメールできます。",
    "over": "合計より {{amount}} 多いです。注文は支払い済みになります。差額は注文ページで処理します（返金かストアクレジット）。",
    "received_at": "入金日時（日本時間）",
    "received_at_hint": "通帳・明細のとおりに。",
    "payer": "振込人名",
    "reference": "銀行の参照",
    "reference_hint": "任意 — 明細の行など。",
    "slip": "振込控え（任意）",
    "slip_from_customer": "お客様の控えが付いています。",
    "note": "メモ（任意）",
    "confirm": "{{amount}} の入金を確認",
    "confirm_hold": "{{amount}} を記録して残りを待つ",
    "confirm_plain": "確認",
    "blocker": {
      "amount_invalid": "届いた金額を入力してください（円・整数）。",
      "choose_short": "金額が足りません — 先にどうするか選んでください。"
    },
    "wait_upload": "控えのアップロードが終わるまでお待ちください。",
    "no_payment": "この注文には確認待ちの銀行振込がありません。",
    "load_failed": "注文を読み込めませんでした。",
    "customer_mail": "お客様に注文確定メールとレシートが届きます。",
    "outcome": {
      "captured": "{{number}}：支払い済み",
      "captured_within_tolerance": "{{number}}：支払い済み（わずかな差を許容）",
      "captured_partial": "{{number}}：一部入金",
      "captured_overpaid": "{{number}}：支払い済み — 多く届いています",
      "held_underpaid": "{{number}}：記録しました — 残りを待っています"
    }
  },
  "ship": {
    "title": "発送 — {{number}}",
    "description": "残りの商品をすべてこの荷物で送ります。",
    "partial_note": "チェックした商品だけ送ります。残りは後で送れます。",
    "what": "荷物に入れるもの",
    "qty_of": "{{qty}} / {{of}}",
    "fewer": "{{title}} を1つ減らす",
    "more": "{{title}} を1つ増やす",
    "carrier": "配送会社",
    "other_carriers": "ほかの配送会社",
    "carriers_failed": "配送会社を読み込めませんでした。もう一度お試しください。",
    "tracking": "追跡番号（スキャンまたは入力）",
    "tracking_hint": "伝票のバーコードをスキャンしてください。",
    "tracking_example": "例：{{example}}",
    "tracking_ok": "形式は正しいようです。",
    "tracking_unusual": "この配送会社の番号の形と違います（例：{{example}}）。確認してください — このまま発送もできます。",
    "test_link": "追跡リンクを試す",
    "no_tracking": "追跡番号なし",
    "no_tracking_title": "追跡番号なしで発送しますか？",
    "no_tracking_consequence": "お客様は荷物を追跡できません。追跡のない配送のときだけ使ってください。",
    "no_tracking_confirm": "番号なしで発送",
    "no_tracking_set": "追跡番号なしで発送します。",
    "add_tracking": "番号を入れる",
    "from": "発送元",
    "when": "発送日時（日本時間）",
    "when_hint": "もっと前に出したとき以外は今のままで。",
    "zonos_id": "Zonos 申告 ID",
    "zonos_hint": "日本郵便で送る米国宛 $100–2,500 は関税の前払いが必要です（伝票に記載）。",
    "high_value": "10万円以上",
    "hv_photos": "商品と箱の写真を撮った",
    "hv_insurance": "全額に保険をかける",
    "hv_not_insurable": "この配送会社は保険がありません — ほかを選んでください",
    "hv_signature": "受け取りのサイン",
    "override": "責任者：それでも送る理由",
    "override_hint": "履歴に残ります。",
    "confirm": "発送",
    "confirm_partial": "この商品を発送",
    "problem": {
      "no_lines": "少なくとも1つチェックしてください。",
      "no_carrier": "配送会社を選んでください。",
      "no_tracking": "追跡番号をスキャン・入力してください（または「追跡番号なし」）。",
      "high_value": "10万円以上の荷物は3つの確認にチェックしてください。"
    },
    "done": "{{number}} を発送しました",
    "done_partial": "{{number}}：一部を発送しました",
    "done_hint": "お客様に追跡リンク付きのメールが届きます。番号の間違いは10分以内なら直せます。",
    "done_hint_no_tracking": "お客様に「発送済み」のメールが届きます。"
  },
  "customs": {
    "title": "税関（表示のみ）",
    "us_ddp": "米国：DDP が必要です — 日本郵便の $100–2,500 の荷物は Zonos で関税の前払いが必要です。",
    "loading": "税関データを読み込み中…",
    "unavailable": "今は税関データを表示できません。",
    "incoterm": "関税",
    "incoterms": {
      "DDP": "店が支払う（DDP）",
      "DDU": "お客様が支払う（DDU）"
    },
    "form": "書式",
    "value": "申告額",
    "weight": "重さ",
    "grams": "{{g}} g",
    "duties_prepaid": "前払いの関税",
    "zonos": "Zonos",
    "zonos_missing": "未入力",
    "warning_other": "税関データを確認してください。",
    "print_invoice": "インボイス（輸出用）を印刷",
    "print_cn": "CN22 / CN23 を印刷",
    "printing": "書類を作成しています — 数秒後「印刷」に表示されます。"
  },
  "parcels": {
    "title_other": "荷物 {{count}} 個",
    "track": "追跡",
    "no_tracking": "追跡番号なし",
    "shipped_at": "発送",
    "in_transit_at": "配送中",
    "delivered_at": "お届け",
    "pickup_ready_at": "店頭受取可",
    "picked_up_at": "受け渡し",
    "mark_in_transit": "配送中",
    "mark_delivered": "お届け済み",
    "deliver_title": "この荷物をお届け済みにしますか？",
    "deliver_consequence": "お客様には「お届け済み」と表示されます。元に戻せません。",
    "fix": "番号を直す",
    "fix_title": "追跡番号を直す",
    "fix_description": "お客様には新しいリンクが届きます。",
    "fix_save": "番号を保存",
    "fixed": "追跡番号を直しました",
    "customer_sees": "お客様の注文ページに表示されます。",
    "done_in_transit": "荷物は配送中です",
    "done_delivered": "荷物はお届け済みです"
  },
  "pickups": {
    "intro": "お店で受け取る注文です。お客様のスマホの注文番号を確認してから渡します。",
    "load_failed": "店頭受取を読み込めませんでした。",
    "waiting_other": "準備完了 — お客様を待っています（{{count}}）",
    "none_waiting": "待っている注文はありません。",
    "to_prepare_other": "準備する（{{count}}）",
    "none_to_prepare": "準備するものはありません。",
    "pay_at_counter": "レジで支払い。",
    "use_pos": "レジで会計してください — 受け渡しもレジで記録されます。",
    "scan": {
      "title": "お客様のQRを読み取る",
      "label": "QRコード（または下の文字）",
      "hint": "お客様のスマホのQR（「受取準備完了」メールから開けます）を読み取るか、下に書かれた文字を入力します。",
      "find": "注文を探す",
      "invalid": "このQRは当店の店頭受取の注文ではありません。注文番号を聞いて下の一覧と照らし合わせてください。",
      "too_short": "コードが短すぎます。もう一度読み取ってください。",
      "not_ready": "まだ受取準備ができていません。先に準備してください。",
      "already": "受け渡し済みです。",
      "cancelled": "この注文はキャンセルされました。商品を渡さないでください。",
      "confirm_body": "QRはこの注文と一致しました。商品をお渡しします（取り消せません）。",
      "handed_over": "{{number}} を受け渡しました"
    }
  },
  "bulk_ship": {
    "title_other": "{{count}} 件を発送",
    "intro": "配送会社を1回選び、追跡番号を順にスキャンします — Enter で次の注文へ。",
    "tracking_for": "{{number}} の追跡番号",
    "skip": {
      "high_value": "10万円以上 — 注文ページから発送してください。",
      "not_ready": "まだ発送できません。"
    },
    "open": "注文を開く",
    "row_done": "発送済み — {{number}}",
    "sending": "送信中",
    "running": "発送中…",
    "confirm_other": "{{count}} 件を発送",
    "done_other": "{{count}} 件を発送しました",
    "partly": "{{ok}} 件発送、{{failed}} 件はできませんでした — 赤い行を確認"
  },
  "draft": {
    "title": "注文を作成（チャット・LINE）",
    "intro": "チャットで買うお客様用です。カードは3日間取り置き。お客様には追跡リンクと振込先がメールで届きます。",
    "customer": "お客様",
    "email": "お客様のメール",
    "language": "お客様の言語",
    "language_hint": "メールはこの言語で届きます。",
    "locales": {
      "en": "English",
      "ja": "日本語",
      "th": "ไทย",
      "zh_Hant": "繁體中文",
      "zh_Hans": "简体中文"
    },
    "items": "商品",
    "scan": "商品をスキャンまたは検索",
    "scan_hint": "商品コード、バーコード、鑑定番号、名前。",
    "no_items": "まだ商品がありません。",
    "remove": "{{title}} を外す",
    "price_hint": "価格・送料・税は注文作成時にシステムが計算します。",
    "delivery": "受け取り方法",
    "payment": "支払い",
    "payment_ship": "支払い：銀行振込（3日以内）。",
    "address": {
      "country": "国",
      "country_hint": "2文字（例：JP、US）",
      "postal_code": "郵便番号",
      "region": "都道府県・州",
      "city": "市区町村",
      "address1": "番地",
      "address2": "建物名・部屋番号",
      "name": "お名前",
      "phone": "電話番号",
      "name_kana": "お名前（カナ）",
      "company": "会社名"
    },
    "note": "メモ（任意）",
    "note_hint": "スタッフ用に注文に表示されます。",
    "create": "注文を作成",
    "creating": "作成中…",
    "problem": {
      "email": "お客様のメールを入力してください。",
      "lines": "商品を1つ以上追加してください。",
      "address": "国・番地・お名前を入力してください。"
    },
    "done": "{{number}} を作成しました",
    "done_hint": "お客様に追跡リンクと振込先のメールが届きます。",
    "done_title": "{{number}} を作成しました",
    "done_body": "カードはお客様のために取り置き中です。リンクをチャットに貼れます。",
    "tracking_link": "お客様の注文ページ",
    "tracking_once": "このリンクは今だけ表示されます。お客様のメールにも入っています。",
    "copy": "リンクをコピー",
    "copied": "コピーしました",
    "open": "注文を開く",
    "another": "別の注文を作成"
  },
  "conflicts": {
    "intro": "確認が必要な問題：二重に売れたカード、確認待ちの注文、履歴と合わない在庫数。",
    "tabs": "問題の種類",
    "tab": {
      "sold-twice": "二重販売",
      "to-check": "確認する注文",
      "stock-differences": "在庫のずれ"
    },
    "show_closed": "決定済みも表示",
    "load_failed": "問題を読み込めませんでした。",
    "none": "二重に売れたカードはありません。",
    "none_body": "ウェブと店頭で同じカードが同時に売れたときにここに出ます。",
    "none_to_check": "確認待ちの注文はありません。",
    "to_check_intro": "問題がある注文、責任者の確認待ちの注文（ネットが切れていた間の店頭販売を含む）。",
    "stock_intro": "毎晩のチェックで在庫数と履歴を比べています。",
    "open_movements": "在庫の履歴を開く",
    "summary": "{{winner}} と {{loser}} が同じカードを買いました",
    "status": {
      "open": "決定が必要",
      "resolved": "決定済み",
      "dismissed": "終了"
    },
    "back": "問題一覧",
    "title": "同じカードが二重に売れました",
    "what": {
      "order_paid": "{{winner}} が先に支払いました。{{loser}} も支払われましたが、カードはもうありませんでした。",
      "offline_commit": "ネットが切れていた間にレジで {{loser}} を販売しましたが、カードは {{winner}} のものでした。",
      "external_paid": "{{winner}} がカードを確保した後に、ほかのお店から {{loser}} が来ました。"
    },
    "side": {
      "winner": "カードを持っている",
      "loser": "カードを受け取れなかった"
    },
    "open_order": "注文を開く",
    "timeline": "経緯",
    "event": {
      "winner": "{{label}}",
      "loser": "{{label}}",
      "detected": "システムが気づいた",
      "resolved": "決定"
    },
    "policy": {
      "external_paid_wins": "使ったルール：支払い済みの販売が、取り置きだけ（未払い）より優先されます。",
      "first_paid_wins": "使ったルール：先に支払った人がカードを受け取ります。"
    },
    "fix": "対応",
    "decision": {
      "keep_winner": "もう一方の注文をキャンセルしてお客様に連絡",
      "dismiss": "確認済みにする",
      "swap_to_loser": "もう一方のお客様にカードを渡す",
      "both_cancelled": "両方キャンセル"
    },
    "note": "何を決めたか、なぜか",
    "note_hint": "履歴に残ります。",
    "note_required": "ひとこと書いてください。",
    "done": {
      "keep_winner": "決定 — もう一方の注文をキャンセルしてお客様に連絡",
      "dismiss": "確認済みにしました",
      "swap_to_loser": "カードはもう一方のお客様に渡ります",
      "both_cancelled": "両方キャンセルしました"
    },
    "cancel_other": "もう一方の注文を開いてキャンセル"
  },
  "refund": {
    "title": "返金 · {{number}}",
    "description": "ここでは記録だけです。お金はお店から送ります（銀行・現金）。商品が戻る場合は「返品を受け付ける」を使ってください。",
    "confirm": "¥{{amount}} の返金を記録",
    "confirm_plain": "返金を記録",
    "nothing": "この注文ではお金を受け取っていないため、返金できません。",
    "which_payment": "どの支払いから？",
    "left": "返金できる上限",
    "already": "返金済み",
    "amount": "返金する金額",
    "why": "理由",
    "reasons": {
      "price_adjustment": "価格の訂正",
      "goodwill": "お詫び",
      "overpayment": "お客様の払いすぎ",
      "other": "その他",
      "order_cancelled": "注文キャンセル",
      "return": "返品",
      "tax_free_refund": "免税の返金"
    },
    "note": "ひとこと（履歴に残ります）",
    "how": "どうやって返しますか？",
    "methods": {
      "original": "支払いと同じ方法",
      "bank_transfer": "お客様の口座へ振込",
      "cash": "店頭で現金",
      "store_credit": "ストアクレジット（6か月有効）",
      "edc_manual": "カード端末で取消"
    },
    "consequence": {
      "original": "お支払いと同じ方法で返してから「記録する」を押してください。",
      "bank_transfer": "銀行で振込をしてから、銀行の番号を入れて「送金しました」を押してください。",
      "cash": "現金をお客様に渡してから「記録する」を押してください。",
      "store_credit": "クレジットはすぐにお客様のアカウントに入ります。",
      "edc_manual": "カード端末で取消をしてから、控えの番号を入れてください。"
    },
    "blocker": {
      "amount_invalid": "金額を円（整数）で入れてください。",
      "amount_too_high": "この支払いで返金できる額を超えています。",
      "note_required": "「その他」はひとこと書いてください。",
      "account_incomplete": "お客様の口座はすべての欄を入れてください（口座番号 7 桁）。わからなければ全部空欄に。"
    },
    "done": "{{number}} の返金を記録しました",
    "done_approval": "送金の前に店長の承認が必要です。",
    "destination": {
      "title": "お客様の口座",
      "hint": "まだわからなければ空欄で。返金は口座がわかるまで待ちます。",
      "bankName": "銀行名",
      "branchName": "支店名",
      "accountType": "種類",
      "accountNumber": "口座番号（7 桁）",
      "accountName": "口座名義（カナ）",
      "types": {
        "futsu": "普通",
        "toza": "当座"
      }
    }
  },
  "refunds": {
    "title": "返金",
    "open_other": "{{count}} 件 やること",
    "phase1": "カード返金は後日対応です。いまはお店が送金して、ここに記録します。",
    "step": {
      "waiting_approval": "承認待ち",
      "hand_cash": "現金を渡す",
      "enter_terminal_reference": "端末で取消",
      "waiting_destination": "口座待ち",
      "transfer_money": "振込する",
      "done": "返金済み",
      "rejected": "承認されず",
      "failed": "失敗"
    },
    "next": {
      "waiting_approval": "別の店長がこの返金を承認する必要があります。",
      "hand_cash": "現金をお客様に渡してから記録してください。",
      "enter_terminal_reference": "カード端末で取消をしてから控えの番号を入れてください。",
      "waiting_destination": "お客様の口座待ち — お客様が注文ページで入力します（まだ使えません。待てない場合は現金かストアクレジットで返金してください）。",
      "transfer_money": "銀行で振込をしてから、銀行の番号を記録してください。",
      "done": "完了 — お客様に返金しました。",
      "rejected": "この返金は承認されませんでした。",
      "failed": "この返金はうまくいきませんでした — メモを見るか、もう一度。"
    },
    "approve": "承認する",
    "reject": "承認しない",
    "done_approve": "返金を承認しました",
    "done_reject": "返金を承認しませんでした",
    "approve_title": "この返金を承認しますか？",
    "approve_consequence": "承認するとお客様へ送金できます。",
    "reject_title": "この返金を承認しませんか？",
    "reject_consequence": "返金は行われません。理由は履歴に残ります。",
    "record": {
      "bank": "送金しました",
      "other": "記録する"
    },
    "record_title": "返金を記録",
    "record_description": {
      "bank": "銀行の振込番号を入れてください。",
      "other": "レシートや控えの番号を入れてください。"
    },
    "record_save": "保存",
    "recorded": "記録しました — お客様に返金済み",
    "recorded_hint": "お客様にはメールと書類が自動で届きます。",
    "reference_required": "銀行または控えの番号を入れてください。",
    "reference": {
      "bank": "振込番号",
      "other": "レシート／控えの番号"
    },
    "reference_hint": "あとで探せるように。",
    "when": "日時",
    "amount": "金額",
    "show_account": "口座を表示",
    "show_account_hint": "表示するたびに記録されます。",
    "no_account": "お客様の口座がまだわかりません — お客様に聞いてください。",
    "ref": "番号",
    "tax_part": "うち消費税"
  },
  "returns": {
    "title": "返品",
    "intro": "お客様から戻る商品：承認 → 受け取り → 1 点ずつ確認 → 返金。",
    "start": "返品を受け付ける",
    "none": "返品はまだありません。",
    "created": "{{number}} の返品を受け付けました",
    "created_hint": "よければ承認してください — お客様に送り方がメールで届きます。",
    "start_title": "返品を受け付ける · {{number}}",
    "start_description": "発送済みで、まだ返金していない商品だけです。",
    "start_confirm": "返品を受け付ける",
    "none_chosen": "1 点以上選んでください。",
    "what": "戻ってくる商品は？",
    "why": "理由",
    "reasons": {
      "damaged_in_transit": "配送中の破損",
      "not_as_described": "説明と違う",
      "wrong_item": "違う商品が届いた",
      "sealed_unopened_7d": "未開封（7 日以内）",
      "legal_8day": "8 日以内（法律）",
      "other": "その他"
    },
    "description": "お客様の説明",
    "override": "それでも受け付ける理由",
    "override_hint": "返品ルールの外です — 店長が理由を書けば受け付けられます。",
    "consigned_note": "委託品：この商品の委託者への支払いは取り消されます。",
    "approve_title": "返品を承認 · {{number}}",
    "approve_description": "お客様に送り方のメールが届きます。",
    "approve": "承認する",
    "approved": "返品を承認しました",
    "approved_hint": "お客様に送り方が届きました。",
    "postage": "返送料はどちらが払いますか？",
    "paid_by": {
      "shop": "お店が払う",
      "customer": "お客様が払う"
    },
    "instructions": "お客様への案内",
    "instructions_placeholder": "例：クリックポストで当店住所へお送りください。",
    "receive": "返品受領 — 荷物が戻った",
    "receive_title": "荷物が戻った · {{number}}",
    "receive_description": "1 点ずつ確認：販売に戻す、または破損。そのあと返金額を計算します。",
    "receive_confirm": "保存して返金を計算",
    "received": "返品を受領しました",
    "received_refund": "返金 ¥{{amount}} — 「返金」欄を見てください。",
    "received_hint": "返金を計算しています。",
    "damage_note_required": "破損した商品には、どこが悪いか書いてください。",
    "arrived": "届いた数",
    "arrived_n_other": "{{count}} 点 到着",
    "state": "状態",
    "disposition": {
      "restock": "販売に戻す",
      "damage": "破損"
    },
    "condition_note": "悪いところ／メモ",
    "location": "戻す場所",
    "location_hint": "棚のどこに戻すか。",
    "location_default": "いつもの場所",
    "refund_amount": "返金",
    "refund_tax": "消費税",
    "henkan_yes": "この返金には返還インボイスが発行されます。",
    "henkan_no": "この返金には返還インボイスは不要です。",
    "refund_status": {
      "pending": "まだ依頼していません — 「もう一度返金を依頼」を押してください。",
      "failed": "返金の依頼がうまくいきませんでした — もう一度。",
      "requested": "記録済み — 送金して記録してください。",
      "approval_required": "店長の承認待ち。",
      "refunded": "返金済み。"
    },
    "status": {
      "requested": "受付",
      "approved": "承認済み — 荷物待ち",
      "rejected": "受け付けない",
      "received": "荷物到着",
      "closed": "完了"
    },
    "reject_reason": "理由：",
    "ask_refund": "もう一度返金を依頼",
    "refund_asked": "返金を依頼しました",
    "reject": "受け付けない",
    "rejected": "返品を受け付けませんでした",
    "reject_title": "この返品を受け付けませんか？",
    "reject_consequence": "お客様に理由つきのメールが届きます。",
    "columns": {
      "order": "注文",
      "status": "状態",
      "reason": "理由",
      "items": "商品",
      "refund": "返金",
      "requested": "受付"
    }
  },
  "edit": {
    "title": "住所の変更 · {{number}}",
    "description": "発送の前まで変更できます。",
    "description_paid": "支払い済み：国を変えると税と送料が変わることがあります — システムが計算し直して表示します。",
    "save": "変更を保存",
    "saved": "変更を保存しました",
    "saved_hint": "お客様の書類は新しい内容になります。",
    "stale": "この注文はいま誰かが変更しました。閉じてもう一度開いてください。",
    "fill_required": "必須の欄を入れてください。",
    "required": "必須",
    "postal_hint": "7 桁で住所の残りが入ります。",
    "postal_found": "住所を入れました — 番地を足してください。",
    "postal_unknown": "この郵便番号は見つかりません — 住所を入れてください。",
    "country_warning": "支払い後に国を変えると、税（国内 10% ↔ 輸出 0%）と送料が変わります。結果を見てから次に進めます。",
    "undo_address": "元の住所に戻す",
    "close": "OK",
    "outcome_title": "変わったこと",
    "tax_changed": "税：{{before}} → {{after}}",
    "total_changed": "合計：",
    "adjustment": {
      "balance_due": "お客様の追加のお支払い：",
      "refund_due": "お客様への返金："
    },
    "notices": {
      "shipping_rate_changed": "送料は新しい住所でいちばん安い方法に変わりました。",
      "other": "ほかにも変わりました — 注文の履歴を見てください。"
    },
    "payment_updated": "お客様の振込金額を更新しました。",
    "no_money_change": "税と合計は変わりません。"
  },
  "documents": {
    "title": "書類",
    "page_title": "書類 · {{number}}",
    "back": "{{number}} に戻る",
    "create": "書類を作る",
    "none": "書類はまだありません。",
    "making": "書類を作っています — できたら自動で開きます。",
    "media_down": "書類のシステムがいま応答しません。少しあとで。",
    "failed": "書類を作れませんでした。もう一度。",
    "same_file": "この書類は前に作ってあります",
    "same_file_hint": "同じファイルを開きます — 新しくは作っていません。",
    "t_number": "領収書の登録番号：",
    "t_number_missing": "未設定 — 設定 › 税",
    "t_number_placeholder": "テスト用の番号 — 設定 › 税 で変更",
    "types": {
      "ryoshusho": "領収書",
      "kani_invoice": "適格簡易請求書",
      "tekikaku_invoice": "適格請求書（宛名つき）",
      "henkan_invoice": "返還インボイス",
      "commercial_invoice": "コマーシャルインボイス（輸出）",
      "packing_slip": "納品書",
      "customs_cn22": "税関告知書 CN22",
      "customs_cn23": "税関告知書 CN23",
      "customs_declaration": "税関告知書（CN22/CN23）",
      "refund_note": "返金のお知らせ",
      "tax_free_slip": "免税の記録",
      "taxfree_explanation": "免税の説明",
      "refund_evidence": "返金の証拠"
    },
    "type_help": {
      "ryoshusho": "ふつうの領収書。",
      "kani_invoice": "登録番号と税つきの領収書。",
      "tekikaku_invoice": "会社向け — 宛名が必要。",
      "packing_slip": "荷物に入れる紙。",
      "commercial_invoice": "海外の税関用。",
      "customs_declaration": "税関ラベルの内容。"
    },
    "unavailable": {
      "not_paid": "お支払いのあとで作れます。",
      "not_export": "海外への荷物だけ。"
    },
    "status": {
      "requested": "作成中",
      "ready": "できました",
      "failed": "作れませんでした",
      "superseded": "新しい版に置き換え"
    },
    "to": "宛名：{{name}}",
    "hash": "指紋",
    "version": "第 {{n}} 版",
    "open": "開く",
    "download": "ダウンロード",
    "resend": "もう一度メール",
    "resent": "メールをもう一度送りました",
    "create_title": "書類を作る · {{number}}",
    "create_description": "お店の情報入りの PDF を作り、7 年間保存します。",
    "create_confirm": "作って開く",
    "which": "どの書類？",
    "recipient": "宛名",
    "recipient_hint": "書類に出す会社名またはお名前。",
    "problem": {
      "recipient_required": "適格請求書には宛名が必要です。"
    },
    "with_prices": "納品書に金額を出す",
    "language": "書類の言語",
    "language_hint": "お客様の言語を選んであります。",
    "preview": "書類",
    "n_of": "{{n}} / {{total}}",
    "previous": "前へ",
    "next": "次へ",
    "print": "印刷",
    "close": "閉じる",
    "loading": "書類を開いています…",
    "bulk_title": {
      "packing_slip_other": "{{count}} 件の納品書",
      "commercial_invoice_other": "{{count}} 件のコマーシャルインボイス"
    },
    "bulk_description": "注文ごとに書類を作ります（あれば同じファイル）。そのあと順番に印刷します。",
    "bulk_print_other": "{{count}} 枚を印刷",
    "bulk_progress": "作成済みの書類",
    "bulk_state": {
      "waiting": "待ち",
      "making": "作成中",
      "ready": "できました",
      "skipped": "不要",
      "failed": "作れませんでした"
    },
    "bulk_open": "順番に印刷"
  }
}
